import React, { Component } from "react";
import FuelAnalytics from "../Common/FuelAnalytics";
export default class FuelConsumptionAnalytics extends Component {
    render() {
        return <FuelAnalytics isVehicle={false} />;
    }
}
